import React from 'react';
import { LayoutProvider } from './context/layout/LayoutProvider';
import { LayoutClassBuilder } from './builders/LayoutClassBuilder';
import './Layout.css'; // optional CSS module or global
import type { LayoutTokenClasses } from './ModularTypes/LayoutSettings';
import type { SectionTokenClasses } from './ModularTypes/SectionSettings';
import type { UnitTokenClasses } from './ModularTypes/UnitSettings';
import type { MicroUnitTokenClasses } from './ModularTypes/MicroUnitSettings';

type LayoutElement = 'div' | 'main';

interface LayoutProps extends LayoutTokenClasses {
  children: React.ReactNode;
  as?: LayoutElement;
  context?: Record<
    string,
    UnitTokenClasses | SectionTokenClasses | MicroUnitTokenClasses
  >;
}

const Layout: React.FC<LayoutProps> = ({ children, as, ...props }) => {
  const className = LayoutClassBuilder.build(props);
  const Component = as ?? 'div';

  return (
    <LayoutProvider context={props.context || {}}>
      <Component className={className}>{children}</Component>
    </LayoutProvider>
  );
};

export default Layout;
